__turbopack_context__.v({
  "card": "CollapsibleTurnrCard-module-scss-module__bpxu9a__card",
  "header-part-wrapper": "CollapsibleTurnrCard-module-scss-module__bpxu9a__header-part-wrapper",
});
